import beforeDestroy from './attrs/beforeDestroy'
import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import props from './attrs/props'

export default {
  name: 'OrderRefund',
  props,
  data,
  computed,
  methods,
  mounted,
  beforeDestroy
}
